import React from 'react';
import './App.scss';
import Header from './components/header/Header';
import IntroPanel from './components/intro-panel/IntroPanel';
import MainPanel from './components/main-panel/MainPanel';
import ModalElement from './components/modals/ModalElement';

export enum ExplorationType {
    Capacities = "Capacities",
    Perspectives = "Perspectives"
}

export enum UIState {
    Intro = "IntroState",
    CapacitiesOpened = "CapacitiesOpenedState",
    PerspectivesOpened = "PerspectivesOpenedState"
}

export enum Capacity {
    General = "GeneralCapacity",
    Reflecting = "ReflectingCapacity",
    Listening = "ListeningCapacity",
    DiscerningPatterns = "DiscerningPatternsCapacity",
    Inquiring = "InquiringCapacity",
    Embodying = "EmbodyingCapacity",
    Relaxing = "RelaxingCapacity",
    Empathizing = "EmpathizingCapacity",
    Sensing = "SensingCapacity",
    Observing = "ObservingCapacity"
}

export enum Perspective {
    General = "GeneralPerspective",
    Mental = "MentalPerspective",
    Emotional = "EmotionalPerspective",
    Physical = "PhysicalPerspective",
    Spiritual = "SpiritualPerspective"
}

interface ComponentState {
    uiState: UIState;
    openedCapacity: Capacity;
    openedPerspective: Perspective;
    modalContent?: JSX.Element;
}

class App extends React.Component<any, ComponentState> {
    constructor(props: {}) {
        super(props);
        const setVh = () => {
            const vh = window.innerHeight * 0.01;
            const vw = window.innerWidth * 0.01;
            const clientWidth = document.body.clientWidth * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            document.documentElement.style.setProperty('--vmax', `${Math.max(vh, vw)}px`);
            document.documentElement.style.setProperty('--clientWidth', `${clientWidth}px`);
            const panelSize = (window.innerWidth - 552 - 204) / (window.innerWidth - 552);
            const translateX = 106;
            document.documentElement.style.setProperty('--charScaleX', `${panelSize}`);
            document.documentElement.style.setProperty('--charTranslateX', `${translateX}px`);
        };

        window.addEventListener('load', setVh);
        window.addEventListener('resize', setVh);

        this.state = { uiState: UIState.Intro, openedCapacity: Capacity.General, openedPerspective: Perspective.General }
    }

    static initialOverflowYValue = '';

    didClickOnPanelMenu = (newState: UIState) => {
        this.setState({ uiState: newState });
    }

    didClickOnCapacityLearnMore = (capacity: Capacity) => {
        console.log("Learn more for " + capacity);
    }

    didClickOnPerspectiveLearnMore = (perspective: Perspective) => {
        console.log("Learn more for " + perspective);
    }

    didClickOnCapacityInCharacterPanel = (capacity: Capacity) => {
        let newState: ComponentState = { openedCapacity: capacity, uiState: this.state.uiState, openedPerspective: this.state.openedPerspective };
        if (this.state.uiState !== UIState.CapacitiesOpened) {
            newState.uiState = UIState.CapacitiesOpened;
        }
        this.setState(newState);
    }

    didClickOnPerspectiveInCharacterPanel = (perspective: Perspective) => {
        let newState: ComponentState = { openedCapacity: this.state.openedCapacity, uiState: this.state.uiState, openedPerspective: perspective };
        if (this.state.uiState !== UIState.PerspectivesOpened) {
            newState.uiState = UIState.PerspectivesOpened;
        }
        this.setState(newState);
    }

    presentModalContent = (content: JSX.Element) => {
        console.log("Present modal");
        this.setState({ modalContent: content });
        App.initialOverflowYValue = document.getElementsByTagName('html')[0].style.overflowY;
        document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
    }

    didCloseModal = () => {
        console.log("Did close modal");
        document.getElementsByTagName('html')[0].style.overflowY = App.initialOverflowYValue;
    }

    render() {
        return (
            <>
                {/* <Header></Header> */}
                <div className="content-innerWrp">
                    <IntroPanel uiState={this.state.uiState}></IntroPanel>
                    <MainPanel didClickOnPanelMenu={this.didClickOnPanelMenu} uiState={this.state.uiState}
                        openedCapacity={this.state.openedCapacity} openedPerspective={this.state.openedPerspective}
                        didClickOnLearnMore={this.didClickOnCapacityLearnMore}
                        didClickOnCapacity={this.didClickOnCapacityInCharacterPanel}
                        didClickOnPerspective={this.didClickOnPerspectiveInCharacterPanel}
                        didClickOnLearnMorePerspective={this.didClickOnPerspectiveLearnMore}
                        presentModalContent={this.presentModalContent}
                    ></MainPanel>
                </div>
                <ModalElement content={this.state.modalContent} closeCallback={this.didCloseModal}></ModalElement>
            </>
        );
    }
}


export default App;
